import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptcha = ({ onVerify }) => {
  const handleVerify = (token) => {
    if (onVerify) {
      onVerify(token);
    }
  };

  return (
    <ReCAPTCHA
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      onChange={handleVerify}
    />
  );
};

export default ReCaptcha; 